var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(" 404 ")]),_c('div',{staticClass:"sub-title"},[_vm._v(" Страница не найдена ")]),_c('router-link',{staticClass:"link",attrs:{"to":{name: 'Home'}}},[_vm._v(" на главную страницу ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }